export const LOADING_OPTIONS_MESSAGE = 'Cargando opciones...';

export const ERROR_FETCHING_OPTIONS = 'Ocurrió un error al obtener las opciones';
